
export enum DashboardAccordionIndexEnum {

  // the number value represents the Accordion using in URLs like /my-zone/dashboard;accordionIndex=2
  open      = 0,
  openForMe = 1,
  completed = 2,

}
